import Routing from "./Pages/Routes";
import Navbar from "./Components/ragini/Navbar";
import Home from "./Pages/Home";
import Header from "./Components/ragini/Header";
import Signup from "./Components/devarshi/Signup/Signup";

import Login from "./Components/devarshi/Login/Login";


function App() {
  
 
  return (
    <div className="App">
      <Routing />
    </div>
  );
}

export default App;
